export default __webpack_public_path__ + "static/media/html.cdf588f5.svg";